import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
import { StockAvailability } from '../utils/stockAvailability/stockAvailability.js';
const StoreAvailabilityContext = createContext(undefined);
export const StoreAvailabilityProvider = ({ children, store, stockLocationId, storeAvailabilityState, productId, onlineAvailabilityState, expectedReleaseDate, isSelected, setSelected, timeTravelOverride, trackSelectedStore, preferredStockLocationId, }) => {
    const schedules = store.schedules || [];
    const getDateIndex = (date) => {
        const currentDay = date.getDay();
        return currentDay === 0 ? 6 : currentDay - 1;
    };
    const now = timeTravelOverride ? new Date(timeTravelOverride) : new Date();
    const dateIndex = getDateIndex(now);
    const weeklyOpeningHours = schedules.slice(dateIndex, dateIndex + 7);
    const isAvailableOnline = StockAvailability.isAvailable(onlineAvailabilityState);
    const isPreOrderOnline = StockAvailability.isPreOrder(onlineAvailabilityState);
    const isPreOrderInStore = StockAvailability.isPreOrder(storeAvailabilityState);
    const isPreOrder = isPreOrderInStore || isPreOrderOnline;
    const isAvailableInStore = StockAvailability.isAvailable(storeAvailabilityState);
    const isAddToCartButtonVisible = isSelected && (isAvailableInStore || isAvailableOnline);
    const isPreferredStore = preferredStockLocationId === Number(stockLocationId);
    return (_jsx(StoreAvailabilityContext.Provider, { value: {
            store,
            weeklyOpeningHours,
            stockLocationId,
            storeAvailabilityState,
            productId,
            isAvailableOnline,
            isPreOrder,
            expectedReleaseDate,
            isSelected,
            isAddToCartButtonVisible,
            setSelected,
            timeTravelOverride,
            trackSelectedStore,
            isPreferredStore,
        }, children: children }));
};
export const useStoreAvailability = () => {
    const context = useContext(StoreAvailabilityContext);
    if (!context) {
        throw new Error('useStoreAvailability must be used within a StoreAvailabilityProvider');
    }
    return context;
};
//# sourceMappingURL=StoreAvailabilityContext.js.map